export const proofReadingPermission = {
  change_traslation: "content.change_translation",
  viewOption: "content.view_option",
  viewExplanation: "content.view_explanation",
  viewTranslation: "content.view_translation",
  viewQuestion: "content.view_question",
};